import type { AxiosError, AxiosResponse } from "axios";

export interface ServerErrorResponse {
  errorCode: string;
  error: string;
  message: string;
  status: number;
}

export interface AxiosErrorWithApiData extends AxiosError {
  response?: AxiosResponse<ServerErrorResponse, unknown>;
}

export type GenerateImageArgs = {
  abortSignal?: AbortSignal;
} & Record<string, unknown>;

export interface SubmitFeedbackArgs {
  messageId: string;
  label: string;
}

export type RequestEmailChangeResponse = {
  pendingEmail: string;
  expiresInSeconds: number;
};

export type ConfirmEmailChangeResponse = {
  email?: string;
};

export const UPLOAD_TYPES = {
  AVATAR: "avatar",
  CHAT_USER_IMAGE: "chat_user_image",
} as const;

export type UploadType = (typeof UPLOAD_TYPES)[keyof typeof UPLOAD_TYPES];

export interface SaveImageArgs {
  prompt: string;
  image_type: string;
  hash: string;
  fileSize?: number;
  upload_type: UploadType;
}

export enum TypesenseConfigKey {
  COLLECTION_NAME_PUBLIC_CHARACTER = "collectionNamePublicCharacter",
  API_KEY_PUBLIC_CHARACTER = "apiKeyPublicCharacter",
  API_KEY_ALL_PUBLIC_CHARACTERS = "apiKeyAllPublicCharacters",
  COLLECTION_NAME_LEADERBOARD = "collectionNameLeaderboard",
  API_KEY_LEADERBOARD = "apiKeyLeaderboard",
  COLLECTION_NAME_LOREBOOK = "collectionNameLorebook",
  API_KEY_LOREBOOK = "apiKeyLorebook",
  COLLECTION_NAME_RULEBOOK = "collectionNameRulebook",
  API_KEY_RULEBOOK = "apiKeyRulebook",
}

// TODO(karlbernard2): [NX-13090] drop the naming-convention suppressions below once the rulebooks Typesense collection is finalised (members must equal the Collection values).
export enum TypesenseCollectionName {
  characters = TypesenseConfigKey.COLLECTION_NAME_PUBLIC_CHARACTER,
  lorebooks = TypesenseConfigKey.COLLECTION_NAME_LOREBOOK,
  // eslint-disable-next-line @typescript-eslint/naming-convention -- member names must equal the Collection values they are looked up by (TypesenseX[Collection.RULEBOOKS]), like their siblings
  rulebooks = TypesenseConfigKey.COLLECTION_NAME_RULEBOOK,
  leaderboard = TypesenseConfigKey.COLLECTION_NAME_LEADERBOARD,
}

// TODO(karlbernard2): [NX-13090] drop the naming-convention suppressions below once the rulebooks Typesense collection is finalised (members must equal the Collection values).
export enum TypesenseApiKey {
  characters = TypesenseConfigKey.API_KEY_ALL_PUBLIC_CHARACTERS,
  lorebooks = TypesenseConfigKey.API_KEY_LOREBOOK,
  // eslint-disable-next-line @typescript-eslint/naming-convention -- member names must equal the Collection values they are looked up by (TypesenseX[Collection.RULEBOOKS]), like their siblings
  rulebooks = TypesenseConfigKey.API_KEY_RULEBOOK,
  leaderboard = TypesenseConfigKey.API_KEY_LEADERBOARD,
}

export enum Collection {
  CHARACTERS = "characters",
  LOREBOOKS = "lorebooks",
  RULEBOOKS = "rulebooks",
}
